import SignaturePad from 'signature_pad';
import angular from 'angular';

export function SignaturePadDirective($interval, $timeout, $window) {
    'ngInject';

    return {
        selector: 'apexSignature',
        restrict: 'EA',
        replace: true,
        template: `
            <div class="signature" style="position: relative; width: 100%; height: 250px;">
               <a href="" ng-click="clear(); $event.preventDefault()"
                     style="position: absolute; top: 10px; right: 10px; z-index: 10;">
                     clear
                  </a>
              <canvas ng-class="{'signature-error': isEmpty}" style="display: block; margin: 0 auto;
                             max-width: {{width}}px;
                             height: 100%;
                             max-height: {{height}}px;
                             min-width: {{minheight}}px;" ng-mouseup="onMouseup()" ng-mouseleave="onMouseleave($event)" ng-mousedown="notifyDrawing({ drawing: true })">
              </canvas>
            </div>
        `,
        scope: {
            accept: '=?',
            clear: '=?',
            disabled: '=?',
            dataurl: '=?',
            height: '@',
            width: '@',
            minheight: '@',
            notifyDrawing: '&onDrawing'
        },
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
            console.log('Directive controller running', $scope);
            var EMPTY_IMAGE = 'w0KGgoAAAANSUhEUgAAAjgAAADcCAQAAADXNhPAAAACIklEQVR42u3UIQEAAAzDsM+/6UsYG0okFDQHMBIJAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEwHMBwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcCQADAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMB8BwAMMBDAfAcADDATAcwHAAwwEwHMBwAAwHMBzAcAAMBzAcAMMBDAcwHADDAQwHwHAAwwEMB8BwAMMBMBzAcADDkQAwHMBwAAwHMBwAwwEMBzAcAMMBDAfAcADDAQwHwHAAwwEwHMBwAMMBMBzAcAAMBzAcwHAADAcwHADDAQwHMBwAwwEMB8BwAMMBMBzAcADDATAcwHAADAcwHMBwAAwHMBwAwwEMBzAcAMMBDAegeayZAN3dLgwnAAAAAElFTkSuQmCC';
            $scope.signaturePad = null;
            $scope.isEmpty = true;
            $scope.accept = function () {
                $scope.dataurl = $scope.signaturePad.isEmpty() ? EMPTY_IMAGE : $scope.signaturePad.toDataURL();
                return {
                    isEmpty: $scope.signaturePad.isEmpty(),
                    dataUrl: $scope.dataurl
                };
            };

            // expose to parent if binding exists
            if ($scope.acceptCallback) {
                $scope.acceptCallback({ fn: $scope.accept });
            }

            $scope.onMouseup = function () {
                $scope.updateModel();
                $scope.notifyDrawing({ drawing: false });
            };

            $scope.onMouseleave = function (event) {
                if (event.buttons & 1 === 1) { // Check if the left mouse button is pressed
                    $scope.notifyDrawing({ drawing: false });// Disable drawing temporarily
                }
            };

            $scope.updateModel = function () {
                $timeout(function () {
                    $scope.dataurl = $scope.signaturePad.toDataURL();
                    $scope.isEmpty = $scope.signaturePad.isEmpty();
                });
            };

            $scope.clear = function () {
                $scope.signaturePad.clear();
                $scope.dataurl = EMPTY_IMAGE;
                $scope.isEmpty = true;       // <� Add this
                $scope.notifyDrawing({ drawing: false }); // <== Add this
            };

            $scope.$watch("dataurl", function (dataUrl) {
                if (dataUrl && $scope.signaturePad.toDataURL() !== dataUrl && dataUrl !== EMPTY_IMAGE) {
                    $scope.setDataUrl(dataUrl);
                }
            });
            console.log('Directive controller running end', $scope);
        }],
        link: function (scope, element, attrs) {
            const canvas = element.find('canvas')[0];
            const parent = canvas.parentElement;
            const ctx = canvas.getContext('2d');

            const width = parseInt(scope.width, 10);
            const height = parseInt(scope.height, 10);

            canvas.width = width;
            canvas.height = height;

            scope.signaturePad = new SignaturePad(canvas);
            scope.signaturePad.minWidth = 2;

            scope.setDataUrl = function (dataUrl) {
                const ratio = Math.max(window.devicePixelRatio || 1, 1);

                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.scale(ratio, ratio);

                scope.signaturePad.clear();
                scope.signaturePad.fromDataURL(dataUrl);

                $timeout(function () {
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.scale(1 / ratio, 1 / ratio);
                });
            };

            scope.$watch('disabled', function (val) {
                if (val) {
                    scope.signaturePad.off();
                } else {
                    scope.signaturePad.on();
                }
            });

            const calculateScale = function () {
                const scaleWidth = Math.min(parent.clientWidth / width, 1);
                const scaleHeight = Math.min(parent.clientHeight / height, 1);
                const newScale = Math.min(scaleWidth, scaleHeight);

                if (newScale === scope.scale) {
                    return;
                }

                const newWidth = width * newScale;
                const newHeight = height * newScale;
                canvas.style.height = Math.round(newHeight) + 'px';
                canvas.style.width = Math.round(newWidth) + 'px';

                scope.scale = newScale;
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.scale(1 / scope.scale, 1 / scope.scale);
            };

            let resizeIH = $interval(calculateScale, 200);
            scope.$on('$destroy', function () {
                $interval.cancel(resizeIH);
                resizeIH = null;
            });

            angular.element($window).bind('resize', calculateScale);
            scope.$on('$destroy', function () {
                angular.element($window).unbind('resize', calculateScale);
            });

            calculateScale();

            //element.on('touchstart', onTouchstart);
            //element.on('touchend', onTouchend);
            angular.element(canvas).on('touchstart', onTouchstart);
            angular.element(canvas).on('touchend', onTouchend);

            function onTouchstart(event) {
                scope.$apply(function () {
                    scope.notifyDrawing({ drawing: true });
                });
                event.preventDefault();
            }

            function onTouchend(event) {
                scope.$apply(function () {
                    scope.updateModel();
                    scope.notifyDrawing({ drawing: false });
                });
                event.preventDefault();
            }
        }
    };
}
